module.exports = __webpack_public_path__ + "media/steps/steps_bcg@2x-b436925d.png";